import { DatePipe } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import Swal from "sweetalert2";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-mentor",
  templateUrl: "./mentor.component.html",
  styleUrls: ["./mentor.component.css"],
})
export class MentorComponent implements OnInit {
  data: any;
  mentorId: any;
  mentordata: any;
  slots: any;
  slotid: any;
  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private datePipe: DatePipe
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.mentorId = params["id"];
    });
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    var body: any = new FormData();
    body.append("mentorid", this.mentorId);
    this.http
      .post(environment.API_URL + "getmentor/", body, { headers })
      .subscribe((Response) => {
        this.data = Response;
        this.mentordata = this.data.mentordata;
        this.slots = this.data.slots;
        console.log(this.slots);
      });
  }

  formatDateAndTime(dateString: string, timeString: string): string {
    if (dateString && timeString) {
      const date = new Date(dateString);
      if (!isNaN(date.getTime())) {
        const formattedDate = this.datePipe.transform(date, "d MMM, h a");
        if (formattedDate) {
          return formattedDate;
        }
      }
    }
    return "";
  }

  selectslot(id: any) {
    this.slotid = id;
    console.log(this.slotid);
  }

  bookslot() {
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    var body: any = new FormData();
    body.append("slotid", this.slotid);
    this.http
      .post(environment.API_URL + "bookslot/", body, { headers })
      .subscribe((Response) => {
        this.data = Response;
        Swal.fire(this.data.status);
      });
  }
}
